<template>
    <div class="wizard">
        <div v-if="storeIsEmpty" class="wizard--starter">
            <ul>
                <li v-if="page == 0" class="wizard__page wizard__page--0">
                    <div class="wizard__content wizard__content--0">
                        <img
                            v-bind:src="generateMediaUrl({ path: 'static/ui/misc/logo.svg' })"
                            width="300"
                            alt=""
                        />

                        <p class="wizard__paragraph wizard__paragraph--0">
                            <span
                                class="wizard__allocution"
                                v-if="
                                    getProp('deha.user.misc.contact_person.salutation') &&
                                        getProp('deha.user.misc.contact_person.last_name')
                                "
                            >
                                Hallo
                                {{
                                    getProp('deha.user.misc.contact_person.salutation') +
                                        ' ' +
                                        getProp('deha.user.misc.contact_person.last_name')
                                }},
                            </span>
                            <span class="wizard__allocution" v-else> Hallo, </span> <br />
                            <span v-html="$helpers.uiText('W001')"></span>
                            <img
                                v-tooltip="$helpers.uiText('W002')"
                                v-bind:src="generateMediaUrl({ path: 'static/ui/misc/help.svg' })"
                                class="help-icon"
                                width="20"
                                alt=""
                            />
                        </p>

                        <button
                            v-on:click.prevent="next"
                            class="button button--icon-right wizard-0__button"
                        >
                            Los geht's
                        </button>
                    </div>
                </li>

                <li v-else-if="page == 1" class="wizard__page wizard__page--1">
                    <div class="wizard__wrap">
                        <div class="wizard__content">
                            <app-wizardprogress :page="page"></app-wizardprogress>

                            <app-wizardhead
                                title="Angaben zu Ihrem Unternehmen"
                                :help="$helpers.uiText('W004')"
                            ></app-wizardhead>

                            <div class="wizard__intro">
                                <p class="wizard__paragraph" v-html="$helpers.uiText('W003')"></p>
                            </div>
                        </div>

                        <div class="wizard__fields wizard__fields--1">
                            <div class="wizard__fields-cols wizard__fields-cols--first">
                                <div class="wizard__fields-cols--inner">
                                    <div class="wizard__col wizard__col-2-5">
                                        <div class="wizard__fields-sub-col-firma1">
                                            <app-text
                                                label="Firmenname"
                                                data-source="deha.user.firma1"
                                                required
                                                :maxlength="255"
                                            ></app-text>
                                        </div>
                                    </div>
                                    <div class="wizard__col wizard__col-3-5">
                                        <div class="wizard__col-3-5-inner-left">
                                            <div class="wizard__fields-sub-cols">
                                                <div
                                                    class="wizard__fields-sub-col-company-name-addition"
                                                >
                                                    <app-text
                                                        label="Firmierung Zusatz"
                                                        data-source="deha.user.misc.firmierung"
                                                        :maxlength="255"
                                                    ></app-text>
                                                </div>
                                            </div>
                                            <div
                                                class="wizard__fields-sub-cols"
                                                v-if="[1, 2, 3].includes(contactPersonCount)"
                                            >
                                                <div class="wizard__fields-sub-col-salutation">
                                                    <app-select
                                                        label="Anrede"
                                                        data-source="deha.user.misc.contact_person.salutation"
                                                        required
                                                        :options="['Frau', 'Herr']"
                                                    ></app-select>
                                                </div>
                                                <div class="wizard__fields-sub-col-first_name">
                                                    <app-text
                                                        label="Inh. Vorname"
                                                        data-source="deha.user.misc.contact_person.first_name"
                                                        required
                                                        :maxlength="255"
                                                    ></app-text>
                                                </div>
                                                <div class="wizard__fields-sub-col-last_name">
                                                    <app-text
                                                        label="Inh. Nachname"
                                                        data-source="deha.user.misc.contact_person.last_name"
                                                        required
                                                        :maxlength="255"
                                                    ></app-text>
                                                </div>
                                            </div>
                                            <div
                                                class="wizard__fields-sub-cols"
                                                v-if="[2, 3].includes(contactPersonCount)"
                                            >
                                                <div class="wizard__fields-sub-col-salutation">
                                                    <app-select
                                                        label="Anrede"
                                                        data-source="deha.user.misc.contact_person_2.salutation"
                                                        required
                                                        :options="['Frau', 'Herr']"
                                                    ></app-select>
                                                </div>
                                                <div class="wizard__fields-sub-col-first_name">
                                                    <app-text
                                                        label="Inh. Vorname"
                                                        data-source="deha.user.misc.contact_person_2.first_name"
                                                        required
                                                        :maxlength="255"
                                                    ></app-text>
                                                </div>
                                                <div class="wizard__fields-sub-col-last_name">
                                                    <app-text
                                                        label="Inh. Nachname"
                                                        data-source="deha.user.misc.contact_person_2.last_name"
                                                        required
                                                        :maxlength="255"
                                                    ></app-text>
                                                </div>
                                            </div>
                                            <div
                                                class="wizard__fields-sub-cols"
                                                v-if="[3].includes(contactPersonCount)"
                                            >
                                                <div class="wizard__fields-sub-col-salutation">
                                                    <app-select
                                                        label="Anrede"
                                                        data-source="deha.user.misc.contact_person_3.salutation"
                                                        required
                                                        :options="['Frau', 'Herr']"
                                                    ></app-select>
                                                </div>
                                                <div class="wizard__fields-sub-col-first_name">
                                                    <app-text
                                                        label="Inh. Vorname"
                                                        data-source="deha.user.misc.contact_person_3.first_name"
                                                        required
                                                        :maxlength="255"
                                                    ></app-text>
                                                </div>
                                                <div class="wizard__fields-sub-col-last_name">
                                                    <app-text
                                                        label="Inh. Nachname"
                                                        data-source="deha.user.misc.contact_person_3.last_name"
                                                        required
                                                        :maxlength="255"
                                                    ></app-text>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="wizard__col-3-5-inner-right">
                                            <button
                                                class="button plus-button"
                                                v-on:click="increaseContactPersonCount"
                                                v-if="[1, 2].includes(contactPersonCount)"
                                            ></button>
                                            <span
                                                class="plus-minus-divider"
                                                v-if="[2].includes(contactPersonCount)"
                                            ></span>
                                            <button
                                                class="button minus-button"
                                                v-on:click="decreaseContactPersonCount"
                                                v-if="[2, 3].includes(contactPersonCount)"
                                            ></button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="wizard__fields-cols">
                                <div class="wizard__col">
                                    <app-text
                                        label="Straße &amp; Hausnummer"
                                        data-source="deha.user.strasse"
                                        required
                                        :maxlength="255"
                                    ></app-text>

                                    <div class="wizard__fields-sub-cols">
                                        <div class="wizard__sub-col-1-4 wizard-1__plz">
                                            <app-text
                                                label="PLZ"
                                                data-source="deha.user.plz"
                                                pattern="^[0-9]{5,6}$"
                                                required
                                                :maxlength="255"
                                            ></app-text>
                                        </div>
                                        <div class="wizard__sub-col-3-4">
                                            <app-text
                                                label="Ort"
                                                data-source="deha.user.ort"
                                                required
                                                :maxlength="255"
                                            ></app-text>
                                        </div>
                                    </div>

                                    <app-select
                                        label="Land"
                                        data-source="deha.user.land"
                                        :options="'Data.countries'"
                                        required
                                    ></app-select>
                                </div>

                                <div class="wizard__col">
                                    <app-text
                                        label="Telefonnummer"
                                        data-source="deha.user.telefon"
                                        pattern="^(([+]{1,2}[0-9]{2,3})|[0]{1})[0-9]{0,10}[\(]{0,1}[0-9]{1,10}[\)]{0,1}[0-9]{1,10}[\s\|\/\|\-]{0,1}[0-9]{2,10}[\s\|\/\|\-]{0,1}[0-9]{0,10}$"
                                        autoformat="phone"
                                        required
                                        :maxlength="255"
                                    ></app-text>

                                    <app-text
                                        label="Faxnummer"
                                        data-source="deha.user.fax"
                                        pattern="^(([+]{1,2}[0-9]{2,3})|[0]{1})[0-9]{0,10}[\(]{0,1}[0-9]{1,10}[\)]{0,1}[0-9]{1,10}[\s\|\/\|\-]{0,1}[0-9]{2,10}[\s\|\/\|\-]{0,1}[0-9]{0,10}$"
                                        autoformat="phone"
                                        :maxlength="255"
                                    ></app-text>

                                    <app-text
                                        label="E-Mail-Adresse"
                                        data-source="deha.user.email"
                                        pattern="^\S+@\S+\.\S{2,8}$"
                                        required
                                        :maxlength="255"
                                    ></app-text>
                                </div>

                                <div class="wizard__col">
                                    <app-select
                                        label="Rechtsform"
                                        data-source="deha.user.rechtsform"
                                        :options="'Data.companyForms'"
                                        revalidate-source="company_form"
                                    ></app-select>

                                    <app-select
                                        label="Registergericht"
                                        data-source="deha.user.registergericht"
                                        :options="'Data.registryCourts'"
                                    ></app-select>

                                    <div class="wizard__fields-sub-cols">
                                        <div class="wizard__sub-col-1-2">
                                            <app-text
                                                label="Umsatzsteuernr."
                                                data-source="deha.user.ustid"
                                                pattern="^DE[0-9]{9}$"
                                                :maxlength="255"
                                                :required="
                                                    getProp('deha.user.rechtsform') === 'GmbH'
                                                "
                                                revalidate-target="company_form"
                                            ></app-text>
                                        </div>
                                        <div class="wizard__sub-col-1-2">
                                            <app-text
                                                label="Handelsregisternr."
                                                data-source="deha.user.handelsregisternummer"
                                                :maxlength="255"
                                                :required="
                                                    getProp('deha.user.rechtsform') === 'GmbH'
                                                "
                                            ></app-text>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div class="wizard__footer">
                            <button
                                v-on:click.prevent="prev"
                                class="button button--icon-back"
                                v-tooltip="'Zurück zur vorherigen Seite'"
                            >
                                zurück
                            </button>
                            <button
                                :disabled="!showSave"
                                v-on:click.prevent="save"
                                class="button button--icon-right"
                            >
                                weiter
                            </button>
                        </div>
                    </div>
                </li>

                <li v-else-if="page == 2" class="wizard__page wizard__page--2">
                    <div class="wizard__wrap">
                        <div class="wizard__content">
                            <app-wizardprogress :page="page"></app-wizardprogress>

                            <app-wizardhead
                                title="Kontaktmöglichkeiten"
                                :help="$helpers.uiText('W006')"
                            ></app-wizardhead>

                            <div class="wizard__intro">
                                <p class="wizard__paragraph" v-html="$helpers.uiText('W005')"></p>
                            </div>
                        </div>

                        <div class="wizard__fields wizard__fields--2">
                            <div class="wizard__fields-cols">
                                <div class="wizard__col">
                                    <app-text
                                        label="Telefonnummer"
                                        data-source="deha.user.telefon_alt"
                                        :data-default="{
                                            type: 'source',
                                            value: 'deha.user.telefon'
                                        }"
                                        pattern="^(([+]{1,2}[0-9]{2,3})|[0]{1})[0-9]{0,10}[\(]{0,1}[0-9]{1,10}[\)]{0,1}[0-9]{1,10}[\s\|\/\|\-]{0,1}[0-9]{2,10}[\s\|\/\|\-]{0,1}[0-9]{0,10}$"
                                        autoformat="phone"
                                        required
                                        :maxlength="255"
                                    ></app-text>

                                    <app-text
                                        label="Faxnummer"
                                        data-source="deha.user.fax_alt"
                                        pattern="^(([+]{1,2}[0-9]{2,3})|[0]{1})[0-9]{0,10}[\(]{0,1}[0-9]{1,10}[\)]{0,1}[0-9]{1,10}[\s\|\/\|\-]{0,1}[0-9]{2,10}[\s\|\/\|\-]{0,1}[0-9]{0,10}$"
                                        :data-default="{ type: 'source', value: 'deha.user.fax' }"
                                        autoformat="phone"
                                        :maxlength="255"
                                    ></app-text>

                                    <app-text
                                        label="E-Mail-Adresse"
                                        data-source="deha.user.email_alt"
                                        :data-default="{ type: 'source', value: 'deha.user.email' }"
                                        pattern="^\S+@\S+\.\S{2,8}$"
                                        required
                                        :maxlength="255"
                                    ></app-text>
                                </div>
                            </div>
                        </div>

                        <div class="wizard__footer">
                            <button
                                v-on:click.prevent="prev"
                                class="button button--icon-back"
                                v-tooltip="'Zurück zur vorherigen Seite'"
                            >
                                zurück
                            </button>
                            <button
                                :disabled="!showSave"
                                v-on:click.prevent="save"
                                class="button button--icon-right"
                            >
                                weiter
                            </button>
                        </div>
                    </div>
                </li>

                <li v-else-if="page == 3" class="wizard__page wizard__page--3">
                    <div class="wizard__wrap">
                        <div class="wizard__content">
                            <app-wizardprogress :page="page"></app-wizardprogress>

                            <app-wizardhead
                                title="Anzahl Mitarbeiter"
                                :help="$helpers.uiText('W008')"
                            ></app-wizardhead>

                            <div class="wizard__intro">
                                <p class="wizard__paragraph" v-html="$helpers.uiText('W007')"></p>
                            </div>
                        </div>

                        <div class="wizard__fields wizard__fields--3">
                            <div class="wizard__fields-cols">
                                <div class="wizard__col">
                                    <app-number
                                        label="Anzahl"
                                        data-source="deha.user.teamanzahl"
                                        :min="0"
                                        :max="100"
                                        required
                                    ></app-number>
                                </div>
                            </div>

                            <p class="wizard__paragraph" v-html="$helpers.uiText('W040')"></p>

                            <div class="wizard__fields-cols">
                                <div class="wizard__col">
                                    <app-radio
                                        data-source="deha.user.misc.needs_privacy_officer"
                                        :data-default="{ type: 'raw', value: '0' }"
                                        :options="{
                                            0: 'nein',
                                            1: 'ja'
                                        }"
                                    ></app-radio>
                                </div>
                            </div>

                            <p class="wizard__paragraph" v-html="$helpers.uiText('W041')"></p>
                        </div>

                        <div class="wizard__footer">
                            <button
                                v-on:click.prevent="prev"
                                class="button button--icon-back"
                                v-tooltip="'Zurück zur vorherigen Seite'"
                            >
                                zurück
                            </button>
                            <button
                                :disabled="!showSave"
                                v-on:click.prevent="
                                    save(needsPrivacyOfficer ? 4 : hasPackageBasic ? 5 : 6)
                                "
                                class="button button--icon-right"
                            >
                                weiter
                            </button>
                        </div>
                    </div>
                </li>

                <li v-else-if="page == 4" class="wizard__page wizard__page--4">
                    <div class="wizard__wrap">
                        <div class="wizard__content">
                            <app-wizardprogress :page="page"></app-wizardprogress>

                            <app-wizardhead
                                title="Datenschutzbeauftragter"
                                :help="$helpers.uiText('W010')"
                            ></app-wizardhead>

                            <div class="wizard__intro">
                                <p class="wizard__paragraph" v-html="$helpers.uiText('W009')"></p>
                            </div>
                        </div>

                        <div class="wizard__fields">
                            <div class="wizard__fields-cols">
                                <div class="wizard__col">
                                    <div class="wizard__fields-sub-cols">
                                        <div class="wizard__sub-col-1-2">
                                            <app-text
                                                label="Vorname"
                                                data-source="deha.user.misc.privacy_officer.first_name"
                                                :data-default="{
                                                    type: 'source',
                                                    value:
                                                        'deha.user.misc.contact_person.first_name'
                                                }"
                                                required
                                                :maxlength="255"
                                            ></app-text>
                                        </div>
                                        <div class="wizard__sub-col-1-2">
                                            <app-text
                                                label="Nachname"
                                                data-source="deha.user.misc.privacy_officer.last_name"
                                                :data-default="{
                                                    type: 'source',
                                                    value: 'deha.user.misc.contact_person.last_name'
                                                }"
                                                required
                                                :maxlength="255"
                                            ></app-text>
                                        </div>
                                    </div>

                                    <app-text
                                        label="E-Mail-Adresse"
                                        data-source="deha.user.misc.privacy_officer.email"
                                        :data-default="{ type: 'source', value: 'deha.user.email' }"
                                        pattern="^\S+@\S+\.\S{2,8}$"
                                        required
                                        :maxlength="255"
                                    ></app-text>

                                    <app-text
                                        label="Telefonnummer"
                                        data-source="deha.user.misc.privacy_officer.phone"
                                        :data-default="{
                                            type: 'source',
                                            value: 'deha.user.telefon'
                                        }"
                                        pattern="^(([+]{1,2}[0-9]{2,3})|[0]{1})[0-9]{0,10}[\(]{0,1}[0-9]{1,10}[\)]{0,1}[0-9]{1,10}[\s\|\/\|\-]{0,1}[0-9]{2,10}[\s\|\/\|\-]{0,1}[0-9]{0,10}$"
                                        autoformat="phone"
                                        required
                                        :maxlength="255"
                                    ></app-text>
                                </div>
                            </div>
                        </div>

                        <div class="wizard__footer">
                            <button
                                v-on:click.prevent="prev"
                                class="button button--icon-back"
                                v-tooltip="'Zurück zur vorherigen Seite'"
                            >
                                zurück
                            </button>
                            <button
                                :disabled="!showSave"
                                v-on:click.prevent="save(hasPackageBasic ? 5 : 6)"
                                class="button button--icon-right"
                            >
                                weiter
                            </button>
                        </div>
                    </div>
                </li>

                <li v-else-if="page == 5" class="wizard__page wizard__page--5">
                    <div class="wizard__wrap">
                        <div class="wizard__content">
                            <app-wizardprogress :page="page"></app-wizardprogress>

                            <app-wizardhead
                                title="Seiten anlegen"
                                :help="$helpers.uiText('W012')"
                            ></app-wizardhead>

                            <div class="wizard__intro">
                                <p class="wizard__paragraph" v-html="$helpers.uiText('W011')"></p>
                            </div>
                        </div>

                        <div class="wizard__fields">
                            <div class="wizard__fields-cols">
                                <div class="wizard__col wizard__col--5">
                                    <app-checkboxes
                                        label="Seiten"
                                        data-source="tecpage.user.settings.misc.basicWizardToCreate"
                                        :options="getBasicOnlyPageTypes"
                                        :default="'all'"
                                        :large="true"
                                        required
                                    >
                                    </app-checkboxes>
                                </div>
                            </div>
                        </div>

                        <div class="wizard__footer">
                            <button
                                v-on:click.prevent="prev(needsPrivacyOfficer ? 4 : 3)"
                                class="button button--icon-back"
                                v-tooltip="'Zurück zur vorherigen Seite'"
                            >
                                zurück
                            </button>
                            <button
                                :disabled="!showSave"
                                v-on:click.prevent="save"
                                class="button button--icon-right"
                            >
                                weiter
                            </button>
                        </div>
                    </div>
                </li>

                <li v-else-if="page == 6" class="wizard__page wizard__page--6">
                    <div class="wizard__wrap">
                        <div class="wizard__content">
                            <app-wizardprogress :page="page"></app-wizardprogress>

                            <app-wizardhead
                                title="Firmenlogo"
                                :help="$helpers.uiText('W014')"
                            ></app-wizardhead>

                            <div class="wizard__intro">
                                <p class="wizard__paragraph" v-html="$helpers.uiText('W013')"></p>
                            </div>
                        </div>

                        <div class="wizard__fields">
                            <div class="wizard__fields-cols">
                                <div class="wizard__col">
                                    <app-filepicker
                                        label="Firmenlogo hochladen"
                                        data-source="deha.user.misc.logo"
                                        accept=".jpg,.png,.gif"
                                    ></app-filepicker>

                                    <p
                                        class="wizard__paragraph wizard__paragraph--6"
                                        v-html="$helpers.uiText('W039')"
                                    ></p>
                                </div>
                            </div>
                        </div>

                        <div class="wizard__footer">
                            <button
                                v-on:click.prevent="
                                    prev(hasPackageBasic ? 5 : needsPrivacyOfficer ? 4 : 3)
                                "
                                class="button button--icon-back"
                                v-tooltip="'Zurück zur vorherigen Seite'"
                            >
                                zurück
                            </button>
                            <button
                                :disabled="!showSave"
                                v-on:click.prevent="save"
                                class="button button--icon-right"
                            >
                                <template v-if="getProp('deha.user.misc.logo')">weiter</template>
                                <template v-else>überspringen</template>
                            </button>
                        </div>
                    </div>
                </li>

                <li v-else-if="page == 7" class="wizard__page wizard__page--7">
                    <div class="wizard__wrap">
                        <div class="wizard__content">
                            <app-wizardprogress :page="page"></app-wizardprogress>

                            <app-wizardhead
                                title="Öffnungszeiten"
                                :help="$helpers.uiText('W016')"
                            ></app-wizardhead>

                            <div class="wizard__intro">
                                <p class="wizard__paragraph" v-html="$helpers.uiText('W015')"></p>
                            </div>
                        </div>

                        <div class="wizard__fields">
                            <app-openingtimes
                                :data-source="'deha.user.misc.openingtimes'"
                            ></app-openingtimes>
                        </div>

                        <div class="wizard__footer">
                            <button
                                v-on:click.prevent="prev"
                                class="button button--icon-back"
                                v-tooltip="'Zurück zur vorherigen Seite'"
                            >
                                zurück
                            </button>
                            <button
                                :disabled="!showSave"
                                v-on:click.prevent="save"
                                class="button button--icon-right"
                            >
                                weiter
                            </button>
                        </div>
                    </div>
                </li>

                <li v-else-if="page == 8" class="wizard__page wizard__page--8">
                    <div class="wizard__wrap">
                        <div class="wizard__content">
                            <app-wizardprogress :page="page"></app-wizardprogress>

                            <app-wizardhead
                                title="Leistungen"
                                :help="$helpers.uiText('W018')"
                            ></app-wizardhead>

                            <div class="wizard__intro">
                                <p class="wizard__paragraph" v-html="$helpers.uiText('W017')"></p>
                            </div>
                        </div>

                        <div class="wizard__fields">
                            <app-compactlist
                                :data-source="'deha.user.misc.sectors'"
                                :data-preset="'Listpresets.sectors'"
                                :default="'all'"
                                required
                            ></app-compactlist>
                        </div>

                        <div class="wizard__footer">
                            <button
                                v-on:click.prevent="prev"
                                class="button button--icon-back"
                                v-tooltip="'Zurück zur vorherigen Seite'"
                            >
                                zurück
                            </button>
                            <button
                                :disabled="!showSave"
                                v-on:click.prevent="save"
                                class="button button--icon-right"
                            >
                                weiter
                            </button>
                        </div>
                    </div>
                </li>

                <li v-else-if="page == 9" class="wizard__page wizard__page--9">
                    <div class="wizard__wrap">
                        <div class="wizard__wrap">
                            <div class="wizard__content">
                                <app-wizardprogress :page="page"></app-wizardprogress>

                                <app-wizardhead
                                    title="Zertifizierungen"
                                    :help="$helpers.uiText('W020')"
                                ></app-wizardhead>

                                <div class="wizard__intro">
                                    <p
                                        class="wizard__paragraph"
                                        v-html="$helpers.uiText('W019')"
                                    ></p>
                                    <p
                                        class="wizard__paragraph"
                                        v-html="$helpers.uiText('R083')"
                                    ></p>
                                </div>
                            </div>

                            <div class="wizard__fields">
                                <div class="wizard__fields-cols">
                                    <div class="wizard__col wizard__col--9">
                                        <app-compactlist
                                            :data-source="'deha.user.misc.certifications'"
                                            :data-preset="'Listpresets.certifications'"
                                        ></app-compactlist>
                                    </div>
                                </div>
                            </div>

                            <div class="wizard__footer">
                                <button
                                    v-on:click.prevent="prev"
                                    class="button button--icon-back"
                                    v-tooltip="'Zurück zur vorherigen Seite'"
                                >
                                    zurück
                                </button>
                                <button
                                    :disabled="!showSave"
                                    v-on:click.prevent="save"
                                    class="button button--icon-right"
                                >
                                    <template
                                        v-if="
                                            getListItems('deha.user.misc.certifications').length > 0
                                        "
                                        >weiter</template
                                    >
                                    <template v-else>überspringen</template>
                                </button>
                            </div>
                        </div>
                    </div>
                </li>

                <li v-else-if="page == 10" class="wizard__page wizard__page--10">
                    <div class="wizard__wrap">
                        <div class="wizard__content">
                            <app-wizardprogress :page="page"></app-wizardprogress>

                            <app-wizardhead
                                title="Marken und Produkte"
                                :help="$helpers.uiText('W022')"
                            ></app-wizardhead>

                            <div class="wizard__intro">
                                <p class="wizard__paragraph" v-html="$helpers.uiText('W021')"></p>
                            </div>
                        </div>

                        <div class="wizard__fields wizard__fields-10">
                            <div class="wizard__fields-10-inner">
                                <app-compactlist
                                    :data-source="'deha.user.misc.brands'"
                                    :data-preset="'Listpresets.brands'"
                                ></app-compactlist>
                            </div>
                        </div>

                        <div class="wizard__footer">
                            <button
                                v-on:click.prevent="prev"
                                class="button button--icon-back"
                                v-tooltip="'Zurück zur vorherigen Seite'"
                            >
                                zurück
                            </button>
                            <button
                                :disabled="!showSave"
                                v-on:click.prevent="save"
                                class="button button--icon-right"
                            >
                                <template v-if="getListItems('deha.user.misc.brands').length > 0"
                                    >weiter</template
                                >
                                <template v-else>überspringen</template>
                            </button>
                        </div>
                    </div>
                </li>

                <li v-else-if="page == 11" class="wizard__page wizard__page--11">
                    <div class="wizard__wrap">
                        <div class="wizard__content">
                            <app-wizardprogress :page="page"></app-wizardprogress>

                            <app-wizardhead
                                title="Dienstleistungen"
                                :help="$helpers.uiText('W024')"
                            ></app-wizardhead>

                            <div class="wizard__intro">
                                <p class="wizard__paragraph" v-html="$helpers.uiText('W023')"></p>
                            </div>
                        </div>

                        <div class="wizard__fields">
                            <div class="wizard__fields-cols">
                                <div class="wizard__col wizard__col--11">
                                    <app-compactlist
                                        :data-source="'deha.user.misc.services'"
                                        :data-preset="'Listpresets.services'"
                                        :default="'all'"
                                    ></app-compactlist>
                                </div>
                            </div>
                        </div>

                        <div class="wizard__footer">
                            <button
                                v-on:click.prevent="prev"
                                class="button button--icon-back"
                                v-tooltip="'Zurück zur vorherigen Seite'"
                            >
                                zurück
                            </button>
                            <button
                                :disabled="!showSave"
                                v-on:click.prevent="save"
                                class="button button--icon-right"
                            >
                                <template v-if="getListItems('deha.user.misc.services').length > 0"
                                    >weiter</template
                                >
                                <template v-else>überspringen</template>
                            </button>
                        </div>
                    </div>
                </li>

                <li v-else-if="page == 12" class="wizard__page wizard__page--12">
                    <div class="wizard__wrap">
                        <div class="wizard__content">
                            <app-wizardprogress :page="page"></app-wizardprogress>

                            <app-wizardhead
                                title="Über uns"
                                :help="$helpers.uiText('W026')"
                            ></app-wizardhead>

                        </div>

                        <div class="wizard__fields">

                            <div class="wizard__fields-cols-desc wizard__fields-cols-desc--center">
                                <p v-html="$helpers.uiText('W025')"></p>
                            </div>
                            <div class="wizard__fields-cols">
                                <div class="wizard__col wizard__col--12">
                                    <app-number
                                        label="Gründungsjahr"
                                        data-source="deha.user.gruendungsjahr"
                                        :min="1850"
                                        :max="new Date().getFullYear()"
                                        required
                                    ></app-number>
                                </div>
                            </div>

                            <div class="wizard__fields-cols-desc">
                                <p v-html="$helpers.uiText('W046')"></p>
                            </div>
                            <div class="wizard__fields-cols">
                                <div class="wizard__col">
                                    <app-text
                                        label="Vorname"
                                        data-source="deha.user.misc.responsible_for_content.first_name"
                                        required
                                        :maxlength="255"
                                    ></app-text>
                                </div>
                                <div class="wizard__col">
                                    <app-text
                                        label="Nachname"
                                        data-source="deha.user.misc.responsible_for_content.last_name"
                                        required
                                        :maxlength="255"
                                    ></app-text>
                                </div>
                                <div class="wizard__col">
                                    <app-text
                                        label="Adresse"
                                        data-source="deha.user.misc.responsible_for_content.address"
                                        required
                                        :maxlength="255"
                                    ></app-text>
                                </div>
                            </div>

                            <!-- regulated profession -->
                            <div class="wizard__fields-cols-desc">
                                <p v-html="$helpers.uiText('W047')"></p>
                            </div>
                            <div class="wizard__fields-cols wizard__fields-cols--left">
                                <div class="wizard__col-regulated-profession-applicable">
                                    <app-select
                                        label="Berufsregelungen liegen vor"
                                        data-source="deha.user.misc.regulated_profession_applicable"
                                        :options="{ 0: 'Nein', 1: 'Ja' }"
                                        hide-clear
                                        required
                                    ></app-select>
                                </div>
                            </div>
                            <div class="wizard__wrap-regulated-profession" v-if="getProp('deha.user.misc.regulated_profession_applicable') === '1'">
                                <div class="wizard__wrap-regulated-profession-inner-left">
                                    <div
                                        class="wizard__fields-cols"
                                        v-if="[1, 2, 3].includes(regulatedProfessionCount)"
                                    >
                                        <div class="wizard__col">
                                            <app-text
                                                label="Berufsbezeichnung"
                                                data-source="deha.user.misc.regulated_profession.job_name"
                                                required
                                                :maxlength="255"
                                            ></app-text>
                                        </div>
                                        <div class="wizard__col">
                                            <app-text
                                                label="Handwerkskammer"
                                                data-source="deha.user.misc.regulated_profession.chamber_name"
                                                required
                                                :maxlength="255"
                                            ></app-text>
                                        </div>
                                        <div class="wizard__col">
                                            <app-text
                                                class="settings__content-field-chamber"
                                                label="Link Handwerkskammer"
                                                data-source="deha.user.misc.regulated_profession.chamber_link"
                                                pattern="^(https?:\/\/(www\.)?)?[\-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([\-a-zA-Z0-9@:%_\+.~#?\&\/\/=]*)$"
                                                autoformat="url"
                                                required
                                                :maxlength="255"
                                            ></app-text>
                                        </div>
                                    </div>
                                    <div
                                        class="wizard__fields-cols"
                                        v-if="[2, 3].includes(regulatedProfessionCount)"
                                    >
                                        <div class="wizard__col">
                                            <app-text
                                                label="Berufsbezeichnung"
                                                data-source="deha.user.misc.regulated_profession_2.job_name"
                                                required
                                                :maxlength="255"
                                            ></app-text>
                                        </div>
                                        <div class="wizard__col">
                                            <app-text
                                                label="Handwerkskammer"
                                                data-source="deha.user.misc.regulated_profession_2.chamber_name"
                                                required
                                                :maxlength="255"
                                            ></app-text>
                                        </div>
                                        <div class="wizard__col">
                                            <app-text
                                                class="settings__content-field-chamber"
                                                label="Link Handwerkskammer"
                                                data-source="deha.user.misc.regulated_profession_2.chamber_link"
                                                pattern="^(https?:\/\/(www\.)?)?[\-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([\-a-zA-Z0-9@:%_\+.~#?\&\/\/=]*)$"
                                                autoformat="url"
                                                required
                                                :maxlength="255"
                                            ></app-text>
                                        </div>
                                    </div>
                                    <div
                                        class="wizard__fields-cols"
                                        v-if="[3].includes(regulatedProfessionCount)"
                                    >
                                        <div class="wizard__col">
                                            <app-text
                                                label="Berufsbezeichnung"
                                                data-source="deha.user.misc.regulated_profession_3.job_name"
                                                required
                                                :maxlength="255"
                                            ></app-text>
                                        </div>
                                        <div class="wizard__col">
                                            <app-text
                                                label="Handwerkskammer"
                                                data-source="deha.user.misc.regulated_profession_3.chamber_name"
                                                required
                                                :maxlength="255"
                                            ></app-text>
                                        </div>
                                        <div class="wizard__col">
                                            <app-text
                                                class="settings__content-field-chamber"
                                                label="Link Handwerkskammer"
                                                data-source="deha.user.misc.regulated_profession_3.chamber_link"
                                                pattern="^(https?:\/\/(www\.)?)?[\-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([\-a-zA-Z0-9@:%_\+.~#?\&\/\/=]*)$"
                                                autoformat="url"
                                                required
                                                :maxlength="255"
                                            ></app-text>
                                        </div>
                                    </div>
                                </div>
                                <div class="wizard__col-3-5-inner-right">
                                    <button
                                        class="button plus-button"
                                        v-on:click="increaseRegulatedProfessionCount"
                                        v-if="[1, 2].includes(regulatedProfessionCount)"
                                    ></button>
                                    <span
                                        class="plus-minus-divider"
                                        v-if="[2].includes(regulatedProfessionCount)"
                                    ></span>
                                    <button
                                        class="button minus-button"
                                        v-on:click="decreaseRegulatedProfessionCount"
                                        v-if="[2, 3].includes(regulatedProfessionCount)"
                                    ></button>
                                </div>
                            </div>

                        </div>

                        <div class="wizard__footer">
                            <button
                                v-on:click.prevent="prev"
                                class="button button--icon-back"
                                v-tooltip="'Zurück zur vorherigen Seite'"
                            >
                                zurück
                            </button>
                            <button
                                :disabled="!showSave"
                                v-on:click.prevent="save"
                                class="button button--icon-right"
                            >
                                weiter
                            </button>
                        </div>
                    </div>
                </li>

                <li v-else-if="page == 13" class="wizard__page wizard__page--13">
                    <div class="wizard__wrap">
                        <div class="wizard__content">
                            <app-wizardprogress :page="page"></app-wizardprogress>

                            <app-wizardhead
                                title="Aussehen Ihrer Webseite"
                                :help="$helpers.uiText('W028')"
                                subtitle="Iconstyles"
                            ></app-wizardhead>

                            <div class="wizard__intro">
                                <p class="wizard__paragraph" v-html="$helpers.uiText('W027')"></p>
                            </div>
                        </div>

                        <div class="wizard__fields">
                            <div class="wizard__fields-cols">
                                <div class="wizard__col wizard__col--13">
                                    <app-iconstyle
                                        data-source="tecpage.user.settings.iconstyle"
                                        :data-default="{ type: 'raw', value: getIconstyleDefault }"
                                        required
                                    ></app-iconstyle>
                                </div>
                            </div>
                        </div>

                        <div class="wizard__footer">
                            <button
                                v-on:click.prevent="prev"
                                class="button button--icon-back"
                                v-tooltip="'Zurück zur vorherigen Seite'"
                            >
                                zurück
                            </button>
                            <button
                                :disabled="!showSave"
                                v-on:click.prevent="save"
                                class="button button--icon-right"
                            >
                                weiter
                            </button>
                        </div>
                    </div>
                </li>

                <li v-else-if="page == 14" class="wizard__page wizard__page--14">
                    <div class="wizard__wrap">
                        <div class="wizard__content">
                            <app-wizardprogress :page="page"></app-wizardprogress>

                            <app-wizardhead
                                title="Aussehen Ihrer Webseite"
                                :help="$helpers.uiText('W030')"
                                subtitle="Farben"
                            ></app-wizardhead>

                            <div class="wizard__intro">
                                <p class="wizard__paragraph" v-html="$helpers.uiText('W029')"></p>
                            </div>
                        </div>

                        <div class="wizard__fields wizard__fields--14">
                            <div class="wizard__fields-cols wizard__fields-cols--14">
                                <div class="wizard__col wizard__col--14">
                                    <app-colorscheme
                                        data-source="tecpage.user.settings.colorscheme"
                                        required
                                    ></app-colorscheme>
                                </div>
                            </div>
                        </div>

                        <div class="wizard__footer">
                            <button
                                v-on:click.prevent="prev"
                                class="button button--icon-back"
                                v-tooltip="'Zurück zur vorherigen Seite'"
                            >
                                zurück
                            </button>
                            <button
                                :disabled="!showSave"
                                v-on:click.prevent="save"
                                class="button button--icon-right"
                            >
                                weiter
                            </button>
                        </div>
                    </div>
                </li>

                <li v-else-if="page == 15" class="wizard__page wizard__page--15">
                    <div class="wizard__wrap">
                        <div class="wizard__content">
                            <app-wizardprogress :page="page"></app-wizardprogress>

                            <app-wizardhead
                                title="Aussehen Ihrer Webseite"
                                :help="$helpers.uiText('W043')"
                                subtitle="Theme"
                            ></app-wizardhead>

                            <div class="wizard__intro">
                                <p class="wizard__paragraph" v-html="$helpers.uiText('W042')"></p>
                            </div>
                        </div>

                        <div class="wizard__fields wizard__fields--15">
                            <app-themepicker
                                data-source="tecpage.user.settings.theme"
                                :data-default="{
                                    type: 'raw',
                                    value: getThemeDefault
                                }"
                                required
                            ></app-themepicker>
                        </div>

                        <div class="wizard__footer">
                            <button
                                v-on:click.prevent="prev"
                                class="button button--icon-back"
                                v-tooltip="'Zurück zur vorherigen Seite'"
                            >
                                zurück
                            </button>
                            <button
                                :disabled="!showSave"
                                v-on:click.prevent="save"
                                class="button button--icon-right"
                            >
                                weiter
                            </button>
                        </div>
                    </div>
                </li>

                <li v-else-if="page == 16" class="wizard__page wizard__page--16">
                    <div class="wizard__wrap">
                        <div class="wizard__content">
                            <app-wizardprogress :page="page"></app-wizardprogress>

                            <app-wizardhead
                                title="Aussehen Ihrer Webseite"
                                :help="$helpers.uiText('W032')"
                                subtitle="Schriftbild"
                            ></app-wizardhead>

                            <div class="wizard__intro">
                                <p class="wizard__paragraph" v-html="$helpers.uiText('W031')"></p>
                            </div>
                        </div>

                        <div class="wizard__fields">
                            <app-fontfamily
                                data-source="tecpage.user.settings.fontfamily"
                                :data-default="{ type: 'raw', value: getFontfamilyDefault }"
                                required
                                :slide-view="true"
                            ></app-fontfamily>
                        </div>

                        <div class="wizard__footer">
                            <button
                                v-on:click.prevent="prev"
                                class="button button--icon-back"
                                v-tooltip="'Zurück zur vorherigen Seite'"
                            >
                                zurück
                            </button>
                            <button
                                :disabled="!showSave"
                                v-on:click.prevent="save"
                                class="button button--icon-right"
                            >
                                weiter
                            </button>
                        </div>
                    </div>
                </li>

                <li v-else-if="page == 17" class="wizard__page wizard__page--17">
                    <div class="wizard__wrap">
                        <div class="wizard__content">
                            <app-wizardprogress :page="page"></app-wizardprogress>

                            <app-wizardhead
                                title="Soziale Medien"
                                :help="$helpers.uiText('W044')"
                            ></app-wizardhead>

                            <div class="wizard__intro">
                                <p class="wizard__paragraph" v-html="$helpers.uiText('W045')"></p>
                            </div>
                        </div>

                        <div class="wizard__fields">
                            <app-socialmedia
                                :data-source="'deha.user.misc.socials'"
                                :data-preset="'Listpresets.socials'"
                            ></app-socialmedia>
                        </div>

                        <div class="wizard__footer">
                            <button
                                v-on:click.prevent="prev"
                                class="button button--icon-back"
                                v-tooltip="'Zurück zur vorherigen Seite'"
                            >
                                zurück
                            </button>
                            <button
                                :disabled="!showSave"
                                v-on:click.prevent="save"
                                class="button button--icon-right"
                            >
                                <template v-if="getListItems('deha.user.misc.socials').length > 0"
                                    >weiter</template
                                >
                                <template v-else>überspringen</template>
                            </button>
                        </div>
                    </div>
                </li>

                <li v-else-if="page == 18" class="wizard__page wizard__page--18">
                    <div class="wizard__wrap">
                        <div class="wizard__content">
                            <app-wizardprogress :page="page"></app-wizardprogress>

                            <app-wizardhead
                                title="Notrufnummer"
                                :help="$helpers.uiText('W034')"
                            ></app-wizardhead>

                            <div class="wizard__intro">
                                <p class="wizard__paragraph" v-html="$helpers.uiText('W033')"></p>
                            </div>
                        </div>

                        <div class="wizard__fields">
                            <div class="wizard__fields-cols">
                                <div class="wizard__col">
                                    <app-text
                                        label="Notrufnummer"
                                        data-source="deha.user.misc.emergency.phone"
                                        pattern="^(([+]{1,2}[0-9]{2,3})|[0]{1})[0-9]{0,10}[\(]{0,1}[0-9]{1,10}[\)]{0,1}[0-9]{1,10}[\s\|\/\|\-]{0,1}[0-9]{2,10}[\s\|\/\|\-]{0,1}[0-9]{0,10}$"
                                        autoformat="phone"
                                        :maxlength="255"
                                    ></app-text>

                                    <app-radio
                                        v-if="getProp('deha.user.misc.emergency.phone')"
                                        data-source="deha.user.misc.emergency.visible"
                                        :data-default="{ type: 'raw', value: 'outside' }"
                                        :options="{
                                            outside:
                                                'Soll außerhalb meiner Geschäftszeiten angezeigt werden',
                                            always: 'Soll immer angezeigt werden'
                                        }"
                                    ></app-radio>
                                </div>
                            </div>
                        </div>

                        <div class="wizard__footer">
                            <button
                                v-on:click.prevent="prev"
                                class="button button--icon-back"
                                v-tooltip="'Zurück zur vorherigen Seite'"
                            >
                                zurück
                            </button>
                            <button
                                :disabled="!showSave"
                                v-on:click.prevent="finish('starter')"
                                class="button button--icon-right"
                            >
                                Seite jetzt generieren
                            </button>
                        </div>
                    </div>
                </li>

                <li v-else-if="page == 19" class="wizard__page wizard__page--launch">
                    <div class="wizard__content wizard__content--launch">
                        <img
                            v-bind:src="generateMediaUrl({ path: 'static/ui/misc/logo.svg' })"
                            width="300"
                            alt=""
                        />

                        <img
                            v-bind:src="generateMediaUrl({ path: 'static/ui/misc/launch.gif' })"
                            alt=""
                            class="wizard__image-launch--launch"
                        />

                        <p
                            class="wizard__paragraph wizard__paragraph--launch"
                            v-html="$helpers.uiText('W035')"
                        ></p>
                    </div>
                </li>
            </ul>
        </div>

        <div v-if="hasPackageChangeRequestedBasic" class="wizard--basic">
            <ul>
                <li
                    v-if="page == 0"
                    class="wizard__page wizard__page--0 wizard__page--basic wizard__page--basic-0"
                >
                    <div class="wizard__content wizard__content--0">
                        <img
                            v-bind:src="generateMediaUrl({ path: 'static/ui/misc/logo.svg' })"
                            width="300"
                            alt=""
                        />

                        <p class="wizard__paragraph wizard__paragraph--0">
                            <span
                                class="wizard__allocution"
                                v-html="$helpers.uiText('W036')"
                            ></span>
                            <br />
                            <span v-html="$helpers.uiText('W037')"></span>
                            <img
                                v-tooltip="$helpers.uiText('W002')"
                                v-bind:src="generateMediaUrl({ path: 'static/ui/misc/help.svg' })"
                                class="help-icon"
                                width="20"
                                alt=""
                            />
                        </p>

                        <button
                            v-on:click.prevent="next"
                            class="button button--icon-right wizard-0__button"
                        >
                            Los geht's
                        </button>
                    </div>
                </li>

                <li
                    v-else-if="page == 1"
                    class="wizard__page wizard__page--basic wizard__page--basic-1"
                >
                    <div class="wizard__wrap">
                        <div class="wizard__content">
                            <app-wizardhead
                                title="Seiten anlegen"
                                :help="$helpers.uiText('W012')"
                            ></app-wizardhead>

                            <div class="wizard__intro">
                                <p class="wizard__paragraph" v-html="$helpers.uiText('W011')"></p>
                            </div>
                        </div>

                        <div class="wizard__fields">
                            <app-checkboxes
                                label="Seiten"
                                data-source="tecpage.user.settings.misc.basicWizardToCreate"
                                :options="getBasicOnlyPageTypes"
                                :default="'all'"
                                :large="true"
                                required
                            >
                            </app-checkboxes>
                        </div>

                        <div class="wizard__footer">
                            <button
                                v-on:click.prevent="prev"
                                class="button button--icon-back"
                                v-tooltip="'Zurück zur vorherigen Seite'"
                            >
                                zurück
                            </button>
                            <button
                                :disabled="!showSave"
                                v-on:click.prevent="finish('basic')"
                                class="button button--icon-right"
                            >
                                weiter
                            </button>
                        </div>
                    </div>
                </li>

                <li
                    v-else-if="page == 2"
                    class="wizard__page wizard__page--basic wizard__page--launch"
                >
                    <div class="wizard__content wizard__content--launch">
                        <img
                            v-bind:src="generateMediaUrl({ path: 'static/ui/misc/logo.svg' })"
                            width="300"
                            alt=""
                        />

                        <img
                            v-bind:src="generateMediaUrl({ path: 'static/ui/misc/launch.gif' })"
                            alt=""
                            class="wizard__image-launch--launch"
                        />

                        <p
                            class="wizard__paragraph wizard__paragraph--launch"
                            v-html="$helpers.uiText('W035')"
                        ></p>
                    </div>
                </li>
            </ul>
        </div>

        <div class="wizard__meta">
            <router-link
                to="/logout"
                class="wizard__meta-logout"
                v-tooltip="$helpers.uiText('U001')"
                >Logout</router-link
            >
        </div>
    </div>
</template>

<script>
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import { exists } from '@/helpers/utils';
import { mapActions, mapGetters } from 'vuex';
import Text from '@/components/fields/simple/Text.vue';
import Number from '@/components/fields/simple/Number.vue';
import Select from '@/components/fields/simple/Select.vue';
import Radio from '@/components/fields/simple/Radio.vue';
import Fontfamily from '@/components/fields/simple/Fontfamily.vue';
import Colorscheme from '@/components/fields/simple/Colorscheme.vue';
import Themepicker from '@/components/fields/simple/Themepicker.vue';
import Iconstyle from '@/components/fields/simple/Iconstyle.vue';
import Filepicker from '@/components/fields/complex/Filepicker.vue';
import OpeningTimes from '@/components/fields/complex/OpeningTimes.vue';
import Compactlist from '@/components/fields/complex/Compactlist.vue';
import Checkboxes from '@/components/fields/complex/Checkboxes.vue';
import SocialMedia from '@/components/fields/complex/SocialMedia.vue';
import WizardProgress from '@/components/assorted/WizardProgress.vue';
import WizardHead from '@/components/assorted/WizardHead.vue';

export default {
    data() {
        return {
            contactPersonCount: 1,
            regulatedProfessionCount: 0,
        };
    },
    components: {
        'app-text': Text,
        'app-number': Number,
        'app-select': Select,
        'app-radio': Radio,
        'app-fontfamily': Fontfamily,
        'app-colorscheme': Colorscheme,
        'app-themepicker': Themepicker,
        'app-iconstyle': Iconstyle,
        'app-openingtimes': OpeningTimes,
        'app-compactlist': Compactlist,
        'app-checkboxes': Checkboxes,
        'app-filepicker': Filepicker,
        'app-wizardprogress': WizardProgress,
        'app-wizardhead': WizardHead,
        'app-socialmedia': SocialMedia
    },
    methods: {
        ...mapActions([
            'finishWizard',
            'forgetDifferInRoute',
            'saveAllData',
            'removeProp',
            'deleteDifferInvalidField'
        ]),
        async save(page = null) {
            await this.forgetDifferInRoute('/wizard' + (this.page > 0 ? '/' + this.page : ''));
            await this.next(page);
            await this.saveAllData();
        },
        async next(page = null) {
            await new Promise((resolve) => {
                this.$router.push(
                    {
                        name: 'wizard',
                        params: { page: typeof page === 'object' ? this.page + 1 : page }
                    },
                    () => {
                        document.documentElement.scroll({ top: top, left: 0, behavior: 'smooth' });
                        resolve();
                    },
                    () => {
                        document.documentElement.scroll({ top: top, left: 0, behavior: 'smooth' });
                        resolve();
                    }
                );
            });
        },
        async prev(page = null) {
            await new Promise((resolve) => {
                this.$router.push(
                    {
                        name: 'wizard',
                        params: {
                            page:
                                typeof page === 'object'
                                    ? this.page > 1
                                        ? this.page - 1
                                        : null
                                    : page
                        }
                    },
                    () => {
                        resolve();
                    },
                    () => {
                        resolve();
                    }
                );
            });
        },
        async finish(type) {
            await this.forgetDifferInRoute('/wizard' + (this.page > 0 ? '/' + this.page : ''));
            await this.next();
            setTimeout(() => {
                this.finishWizard(type).catch(() => {});
            }, 3000);
        },

        // handle contact person
        increaseContactPersonCount() {
            this.addContactPersonCount(1);
        },
        decreaseContactPersonCount() {
            this.addContactPersonCount(-1);
            ['salutation', 'first_name', 'last_name'].forEach((props__value) => {
                this.removeProp({
                    source:
                        'deha.user.misc.contact_person_' +
                        (this.contactPersonCount + 1) +
                        '.' +
                        props__value
                });
                this.deleteDifferInvalidField({
                    source:
                        'deha.user.misc.contact_person_' +
                        (this.contactPersonCount + 1) +
                        '.' +
                        props__value,
                    route: this.getCurrentRouteFullPath
                });
            });
        },
        addContactPersonCount(i) {
            let value = this.contactPersonCount;
            if (value !== undefined && value !== null && value !== '') {
                value = parseInt(value) + i;
            } else {
                value = 1;
            }
            this.contactPersonCount = value;
        },

        // handle regulated professions
        increaseRegulatedProfessionCount() {
            this.addRegulatedProfessionCount(1);
        },
        decreaseRegulatedProfessionCount() {
            this.addRegulatedProfessionCount(-1);
            ['job_name', 'chamber_name', 'chamber_link'].forEach((props__value) => {
                const currentCount = this.regulatedProfessionCount;
                const id = (currentCount == 0 ? '' : '_' + (currentCount + 1))
                this.removeProp({
                    source: 'deha.user.misc.regulated_profession' + id + '.' + props__value,
                });
                this.deleteDifferInvalidField({
                    source: 'deha.user.misc.regulated_profession' + id + '.' + props__value,
                    route: this.getCurrentRouteFullPath
                });
            });
        },
        addRegulatedProfessionCount(i) {
            let value = this.regulatedProfessionCount;
            if (value !== undefined && value !== null && value !== '') {
                value = parseInt(value) + i;
            } else {
                value = 1;
            }
            this.regulatedProfessionCount = value;
        },

        exists
    },
    computed: {
        ...mapGetters([
            'getListItems',
            'getProp',
            'differHasChangesInRoute',
            'differHasInvalidFieldsInRoute',
            'generateMediaUrl',
            'hasPackageBasic',
            'needsPrivacyOfficer',
            'getBasicOnlyPageTypes',
            'storeIsEmpty',
            'hasPackageChangeRequestedBasic',
            'getFontfamilyDefault',
            'getThemeDefault',
            'getIconstyleDefault',
            'getUserClientId',
            'getCurrentRouteFullPath',
            'getContrastColor'
        ]),
        showSave() {
            return !this.differHasInvalidFieldsInRoute(
                '/wizard' + (this.page > 0 ? '/' + this.page : '')
            );
        },
        logo() {
            return this.getProp('deha.user.misc.logo.id');
        },
        regulatedProfessionApplicable() {
            return this.getProp('deha.user.misc.regulated_profession_applicable');
        },
    },
    created() {

        // set contact person count
        let counter = 1;
        if (
            this.getProp('deha.user.misc.contact_person_2.salutation') ||
            this.getProp('deha.user.misc.contact_person_2.first_name') ||
            this.getProp('deha.user.misc.contact_person_2.last_name')
        ) {
            counter = 2;
        }
        if (
            this.getProp('deha.user.misc.contact_person_3.salutation') ||
            this.getProp('deha.user.misc.contact_person_3.first_name') ||
            this.getProp('deha.user.misc.contact_person_3.last_name')
        ) {
            counter = 3;
        }
        this.contactPersonCount = counter;

        // set regulated profession count
        let counter_regulated_profession = 0;
        if (this.getProp('deha.user.misc.regulated_profession_applicable') === '1') {
            counter_regulated_profession = 1;
            if (
                this.getProp('deha.user.misc.regulated_profession_2.job_name') ||
                this.getProp('deha.user.misc.regulated_profession_2.chamber_name') ||
                this.getProp('deha.user.misc.regulated_profession_2.chamber_link')
            ) {
                counter_regulated_profession = 2;
            }
            if (
                this.getProp('deha.user.misc.regulated_profession_3.job_name') ||
                this.getProp('deha.user.misc.regulated_profession_3.chamber_name') ||
                this.getProp('deha.user.misc.regulated_profession_3.chamber_link')
            ) {
                counter_regulated_profession = 3;
            }
        }
        this.regulatedProfessionCount = counter_regulated_profession;

    },
    watch: {
        regulatedProfessionApplicable(newVal) {
            if (newVal == '1') {
                this.addRegulatedProfessionCount(1);
            } else {
                if (this.regulatedProfessionCount === 3) {
                    this.decreaseRegulatedProfessionCount();
                }
                if (this.regulatedProfessionCount === 2) {
                    this.decreaseRegulatedProfessionCount();
                }
                if (this.regulatedProfessionCount === 1) {
                    this.decreaseRegulatedProfessionCount();
                }
            }
        },
    },
    props: {
        page: Number
    }
};
</script>
